import { TextWidget as Text } from "@ecologi/react-components/src/TextWidget";
import { useRouter } from "next/router";

export default function TextWidget(props) {
  const router = useRouter();
  return <Text {...props} slug={router?.query?.slug} />;
}
